import { Alert, CollapseProps, Typography } from 'antd'

const { Title } = Typography

export const helpItems: CollapseProps['items'] = [
    {
        key: '1',
        label: <b>Обзор раздела и вкладки</b>,
        children: (
            <>
                <p>
                    Раздел «Приход материала» — список заказов материалов у поставщиков, которые
                    ожидаются на складе или уже приняты. Сами заказы создаются в разделе «Закупки /
                    Материалы» на вкладке «Заказы» и после этого появляются здесь.
                </p>
                <Title level={3}>Вкладки</Title>
                <ul>
                    <li>
                        <b>Ожидаемые</b> — приходы в статусах «Создан», «Прибыл» и «В приемке».
                        Сначала идут самые старые заказы.
                    </li>
                    <li>
                        <b>Завершенные</b> — приходы в статусах «Завершен» и «Отменен». Сначала идут
                        самые новые заказы.
                    </li>
                </ul>
            </>
        ),
    },
    {
        key: '2',
        label: <b>Колонки таблицы</b>,
        children: (
            <>
                <p>
                    Одна строка таблицы — один заказ. Если в заказе несколько позиций, общие поля
                    заказа объединены на все его позиции.
                </p>
                <ul>
                    <li>
                        <b>Номер заказа</b> — номер прихода.
                    </li>
                    <li>
                        <b>Поставщик</b> — поставщик материала.
                    </li>
                    <li>
                        <b>Статус</b> — текущий статус прихода.
                    </li>
                    <li>
                        <b>Дата заказа</b> — когда заказ создан.
                    </li>
                    <li>
                        <b>Дата прихода</b> — ожидаемая дата поступления материала.
                    </li>
                    <li>
                        <b>Позиции заказа</b>: <b>Тип материала</b>, <b>Ширина</b>, <b>Кол-во</b> с
                        единицей измерения и <b>Инициатор</b> — пользователь, инициировавший закупку
                        позиции.
                    </li>
                    <li>
                        <b>Действия</b> — редактирование и приёмка заказа (только на вкладке
                        «Ожидаемые»).
                    </li>
                </ul>
            </>
        ),
    },
    {
        key: '3',
        label: <b>Фильтры</b>,
        children: (
            <>
                <p>
                    Фильтры находятся в первой строке таблицы и применяются сразу после изменения:
                </p>
                <ul>
                    <li>
                        <b>Поставщик</b>.
                    </li>
                    <li>
                        <b>Статус</b> — можно выбрать несколько. Учитываются только статусы текущей
                        вкладки: например, «Завершен» на вкладке «Ожидаемые» ничего не покажет.
                    </li>
                    <li>
                        <b>Дата создания</b> и <b>Дата прихода</b> — заказы за выбранный день.
                    </li>
                    <li>
                        <b>Тип материала</b> и <b>Ширина</b> — заказы, в которых есть позиция с
                        таким материалом. Список ширин зависит от выбранного типа материала; при
                        смене типа ширина сбрасывается.
                    </li>
                </ul>
                <p>
                    Кнопка <b>«Сброс»</b> очищает все фильтры. Фильтры сохраняются в адресе
                    страницы, поэтому ссылкой с фильтрами можно поделиться.
                </p>
            </>
        ),
    },
    {
        key: '4',
        label: <b>Статусы прихода</b>,
        children: (
            <>
                <ul>
                    <li>
                        <b>Создан</b> — заказ оформлен, материал ожидается.
                    </li>
                    <li>
                        <b>Прибыл</b> — материал поступил на склад.
                    </li>
                    <li>
                        <b>В приемке</b> — материал принимается на складе.
                    </li>
                    <li>
                        <b>Завершен</b> — приход принят, материал зачислен в остатки.
                    </li>
                    <li>
                        <b>Отменен</b> — заказ отменён, материал не поступит.
                    </li>
                </ul>
                <Alert
                    showIcon
                    message='В этом разделе статус «Завершен» приход получает только через кнопку «Принять заказ».'
                    type='info'
                />
            </>
        ),
    },
    {
        key: '5',
        label: <b>Редактирование заказа</b>,
        children: (
            <>
                <p>
                    Кнопка с карандашом в колонке «Действия» открывает окно заказа. Кнопки действий
                    есть только на вкладке «Ожидаемые»; завершённые и отменённые приходы не
                    редактируются.
                </p>
                <Title level={3}>Что можно изменить</Title>
                <ul>
                    <li>
                        <b>Дата прихода</b>.
                    </li>
                    <li>
                        <b>Кол-во</b> в позициях — клик по ячейке в таблице позиций.
                    </li>
                </ul>
                <p>Изменения сохраняются автоматически, отдельной кнопки сохранения нет.</p>
                <Title level={3}>Что изменить нельзя</Title>
                <p>Номер заказа, поставщик, статус и дата заказа доступны только для просмотра.</p>
                <Alert
                    showIcon
                    message='Чтобы завершить приход, используйте кнопку «Принять заказ»: статус в окне заказа не меняется.'
                    type='warning'
                />
            </>
        ),
    },
    {
        key: '6',
        label: <b>Приёмка заказа</b>,
        children: (
            <>
                <p>
                    Кнопка с галочкой <b>«Принять заказ»</b> в колонке «Действия» оприходует
                    материал. Подтверждения нет: приёмка выполняется сразу после нажатия.
                </p>
                <Title level={3}>Что происходит при приёмке</Title>
                <ul>
                    <li>
                        Количество по каждой позиции зачисляется в остатки — раздел «Остатки /
                        Материалы».
                    </li>
                    <li>Для позиций, заказанных под отгрузку, материал резервируется за ней.</li>
                    <li>Приход получает статус «Завершен» и переходит на вкладку «Завершенные».</li>
                </ul>
                <Alert
                    showIcon
                    message='Перед приёмкой проверьте количество в позициях: принять завершённый приход повторно нельзя.'
                    type='warning'
                />
            </>
        ),
    },
]
